module.exports = __webpack_public_path__ + "static/media/IMG_20161024_211539.025f2fe7.jpg";